export default __webpack_public_path__ + "static/media/text-align-right.9feb5c13.svg";